import { getHome } from './Home';
export { getPostsByGenre, getPostsByGenreResult, getByGenre } from './Genre';
export {
  getByList,
  getByListWithImage,
  ListLimit,
  getByListWithImageResult,
  postList,
} from './List';
export { getPostView, getPosts } from './Posts';
export default getHome;
